import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class VendorService {
  private vendorsURL = 'vendors';

  constructor(private httpClient: HttpClientService) {}

  addMatter(vendor_id: number, matter_id: number): Promise<any> {
    return this.httpClient.put(`${this.vendorsURL}/${vendor_id}.json`, {
      add_matter: true,
      matter_id: matter_id,
    });
  }

  deleteVendor(vendor_id: number): Promise<any> {
    return this.httpClient.delete(`${this.vendorsURL}/${vendor_id}.json`);
  }

  getFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}.json`, { get_form_options: true });
  }

  getMatters(vendor_id: number, contact_matters: boolean = false): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}/${vendor_id}.json`, { get_matters: true, contact_matters: contact_matters });
  }

  getSearchOptions(): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}.json`, { get_search_options: true });
  }

  getToBePaids(vendor_id: number, params: any): Promise<any> {
    params.get_to_be_paids = true;
    return this.httpClient.get(`${this.vendorsURL}/${vendor_id}.json`, params);
  }

  getVendor(vendor_id: number): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}/${vendor_id}.json`);
  }

  getVendorEdit(vendor_id: number): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}/${vendor_id}/edit.json`);
  }

  getVendors(search_params: any): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}.json`, search_params);
  }

  getVendorsByMatter(matter_id: number): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}.json`, { vendors_by_matter: true, matter_id: matter_id });
  }

  removeMatter(vendor_id: number, matter_id: number): Promise<any> {
    return this.httpClient.put(`${this.vendorsURL}/${vendor_id}.json`, {
      remove_matter: true,
      matter_id: matter_id,
    });
  }

  saveVendor(params: any): Promise<any> {
    if (params.vendor.id) {
      params.update_vendor = true;
      return this.httpClient.put(`${this.vendorsURL}/${params.vendor.id}.json`, params);
    } else {
      params.create_vendor = true;
      return this.httpClient.post(`${this.vendorsURL}.json`, params);
    }
  }

  searchByMatter(matter_id: any = undefined): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}.json`, { vendor_select_search: true, matter_id: matter_id });
  }
}
